var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import history from '../../history';
import { useRouter } from '../../context/router-context';
import { Helmet } from 'react-helmet';
import { colors } from '../../colors';
export var StaticPage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n\n  display: flex;\n  flex-direction: column;\n\n  will-change: transform;\n  transition: none;\n  transform: translateX(0);\n  z-index: 0;\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n\n  display: flex;\n  flex-direction: column;\n\n  will-change: transform;\n  transition: none;\n  transform: translateX(0);\n  z-index: 0;\n"])), colors.app.background);
export var Page = styled(StaticPage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.page-transition-enter {\n    transform: ", ";\n    z-index: ", ";\n  }\n\n  &.page-transition-enter-active {\n    transition: transform 200ms cubic-bezier(0, 0, 0, 1);\n    transform: translateX(0);\n  }\n\n  &.page-transition-exit {\n    transform: translateX(0);\n  }\n\n  &.page-transition-exit-active {\n    transition: transform 200ms cubic-bezier(0, 0, 0, 1);\n    transform: ", ";\n  }\n"], ["\n  &.page-transition-enter {\n    transform: ",
    ";\n    z-index: ", ";\n  }\n\n  &.page-transition-enter-active {\n    transition: transform 200ms cubic-bezier(0, 0, 0, 1);\n    transform: translateX(0);\n  }\n\n  &.page-transition-exit {\n    transform: translateX(0);\n  }\n\n  &.page-transition-exit-active {\n    transition: transform 200ms cubic-bezier(0, 0, 0, 1);\n    transform: ",
    ";\n  }\n"])), function (props) {
    return props.transition === 'back' ? 'translateX(-50%)' : 'translateX(100%)';
}, function (props) { return (props.transition === 'back' ? '0' : '1'); }, function (props) {
    return props.transition === 'back' ? 'translateX(100%)' : 'translateX(-50%)';
});
var OuterBody = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n"], ["\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n"])));
var InnerBody = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  max-width: 1366px;\n  overflow: auto;\n"], ["\n  flex: 1;\n  max-width: 1366px;\n  overflow: auto;\n"])));
export var Body = function (props) {
    return (_jsx(OuterBody, { children: _jsx(InnerBody, __assign({}, props), void 0) }, void 0));
};
export var PageRoute = function (props) {
    var children = props.children, defaultHistory = props.defaultHistory, title = props.title, rest = __rest(props, ["children", "defaultHistory", "title"]);
    var getDirection = useRouter().getDirection;
    var path = props.path;
    if (typeof path !== 'string') {
        throw new Error('Path should be a string');
    }
    var direction = getDirection(defaultHistory, path);
    return (_jsx(Route, __assign({}, rest, { exact: true, render: function (routeProps) {
            return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: title }, void 0) }, void 0),
                    _jsx(Page, __assign({ transition: direction, "data-test": props['data-test'] }, { children: React.cloneElement(children, routeProps) }), void 0)] }, void 0));
        } }), void 0));
};
export var PageRouter = function (props) {
    return (_jsx(Router, __assign({ history: history }, { children: _jsx(Route, { render: function (_a) {
                var location = _a.location;
                return (_jsx(TransitionGroup, __assign({ component: null }, { children: _jsx(CSSTransition, __assign({ classNames: 'page-transition', timeout: 200 }, { children: _jsx(Switch, __assign({ location: location }, { children: props.children }), void 0) }), location.pathname) }), void 0));
            } }, void 0) }), void 0));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=PageRouter.js.map